module.exports = __webpack_public_path__ + "img/preview.5ed2225b.svg";